import React, { useState, useEffect } from 'react';
import { getAllTenants, setTenantStatus } from '../firebase/tenants';
import './SuperAdmin.css';

function TenantList({ onEdit, onCreateNew }) {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    const result = await getAllTenants();
    if (result.success) {
      setTenants(result.tenants || []);
    } else {
      setError(result.message || 'Failed to load tenants');
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const handleStatusToggle = async (tenant) => {
    const newStatus = tenant.status === 'active' ? 'suspended' : 'active';
    const result = await setTenantStatus(tenant.id, newStatus);
    if (result.success) {
      load();
    } else {
      alert(result.message || 'Failed to update status');
    }
  };

  if (loading) {
    return <div className="super-admin-loading">Loading tenants...</div>;
  }
  if (error) {
    return <div className="super-admin-error">{error}</div>;
  }

  return (
    <div className="tenant-list-container">
      <div className="tenant-list-header">
        <h2>Tenants (Gyms)</h2>
        <button type="button" className="super-admin-btn primary" onClick={onCreateNew}>
          + Create Tenant
        </button>
      </div>
      {tenants.length === 0 ? (
        <p className="super-admin-empty">No tenants yet. Create one to get started.</p>
      ) : (
        <table className="tenant-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Slug</th>
              <th>Tenant ID</th>
              <th>Status</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tenants.map((t) => (
              <tr key={t.id}>
                <td>{t.name}</td>
                <td>
                  <code>/gym/{t.slug}</code>
                </td>
                <td>
                  <code className="tenant-id-cell" title="Use this as tenantId when creating tenant admin in Firebase">{t.id}</code>
                  <button
                    type="button"
                    className="super-admin-btn small"
                    style={{ marginLeft: 6 }}
                    onClick={() => { navigator.clipboard.writeText(t.id); alert('Tenant ID copied'); }}
                  >
                    Copy
                  </button>
                </td>
                <td>
                  <span className={`tenant-status ${t.status}`}>{t.status}</span>
                </td>
                <td>{t.createdAt ? new Date(t.createdAt).toLocaleDateString() : '-'}</td>
                <td>
                  <button
                    type="button"
                    className="super-admin-btn small"
                    onClick={() => onEdit(t)}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className={`super-admin-btn small ${t.status === 'active' ? 'warning' : 'success'}`}
                    onClick={() => handleStatusToggle(t)}
                  >
                    {t.status === 'active' ? 'Suspend' : 'Activate'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default TenantList;
